<template>
  <VContainer class="had-kids-in-the-uk-page">
    <VRow>
      <VCol cols="12">
        <div class="had-kids-in-the-uk-page__content">
          <p>If you were a Stay-at-Home Mum in the UK minding children between 1978 – 2010</p>
          <p>
            <b><i>And</i></b>
          </p>
          <p>Your household got Child Benefit (as 90% of Mum’s did in their own name)</p>
          <p>
            <b><i>Then</i></b>
          </p>
          <p>Your National Insurance Record may well be wrong (which could cost you many thousands in lost pension)</p>
          <p><b>The critical Question here is:</b></p>
          <ul>
            <li>Did you start claiming child benefit for your children before 2001?</li>
            <li>If you did, there may well be a problem that noone knows about.</li>
            <li>This is something called HRP - Home Responsibilities Protection.</li>
          </ul>
          <p>
            <b>NEXT STEP:</b> <router-link :to="{ name: 'Contact Us' }">Contact Us</router-link> and we’ll fix the
            problem for you by contacting both HMRC and DWP.
          </p>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>
<script>
import { mapActions } from 'vuex';
// Utils
export default {
  name: 'HadKidsInTheUKPage',
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar'])
  }
};
</script>
